<template>
  <div id="snippets" class="pa-5">
    <!-- tabs -->
    <v-card>
      <v-tabs v-model="tab" centered>
        <v-tab v-for="item in tabs" :key="item.id">
          {{ item.name }}
        </v-tab>
      </v-tabs>
    </v-card>

    <!--tab content-->
    <v-tabs-items class="transparent-bg mt-6" v-model="tab">
      <v-tab-item v-for="tab in tabs" :key="tab.id">
        <!--tab-->
        <draggable v-model="tab.snippets" handle=".handle" class="row" @change="onSortSnippets">
          <v-col cols="12" md="6" lg="6" v-for="snippet of tab.snippets" :key="snippet.id">
            <v-card class="snippet" flat>
              <!--buttons-->
              <div class="manage px-3">
                <v-btn class="handle" x-small icon>
                  <v-icon>mdi-cursor-move</v-icon>
                </v-btn>
                <v-btn class="float-right mt-1" color="accent" x-small icon @click="onDeleteSnippet(snippet)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="float-right mt-1 mx-3" x-small icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-category-edit-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(category, index) in tabs" :key="index" v-if="tab.name !== category.name" link @click="onMoveSnippet(snippet.id, category.id)">
                      <v-list-item-title>{{ category.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <!--snippet-->
              <perfect-scrollbar>
                <v-card-text class="snippet_edit_area py-0 pre-formatted" v-html="snippet.body" contenteditable="true" @focusout="onChangeSnippet($event, snippet.id)"/>
              </perfect-scrollbar>
            </v-card>
          </v-col>
        </draggable>
      </v-tab-item>
    </v-tabs-items>

    <!--add snippet button-->
    <v-fab-transition>
      <v-btn class="mr-16 mb-10" dark fixed bottom right fab @click="onAddSnippet">
        <v-icon>mdi-file-code-outline</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="dialog_sort" scrollable max-width="300px">
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn class="mb-10" dark fixed bottom right fab v-bind="attrs" v-on="on">
            <v-icon>mdi-folder-cog-outline</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
      <v-card>
        <v-card-title>Categorys</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px; padding-top: 20px;">
          <draggable :list="tabs" handle=".handle" class="row" @change="onSortCategorys">

            <div v-for="(tab, i) in tabs" :key="i" style="width: 100%">
              <v-text-field :value="tab.name" counter="20" maxlength="20">
                <v-icon slot="prepend" class="handle">mdi-cursor-move</v-icon>
              </v-text-field>
            </div>

          </draggable>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialog_add = true">Add</v-btn>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click="dialog_sort = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_add" width="300">
      <v-card>
        <v-card-title>Add Category</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 120px; padding-top: 20px;">
          <v-text-field label="Category name" v-model="add_category_name" counter="20" maxlength="20"/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="onAddCategory">Add</v-btn>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click="dialog_add = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_del" max-width="300">
      <v-card>
        <v-card-title class="headline">
          Delete Snippet?
        </v-card-title>
        <v-card-text>{{ dialog_del_snippet.body }}</v-card-text>
        <v-card-actions>
          <v-btn color="secondary lighten-3" text @click="dialog_del = false; dialog_del_snippet = {};">Cancel</v-btn>
          <v-spacer/>
          <v-btn color="accent" text @click="onConfirmSnippetDel">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import draggable from 'vuedraggable'

  export default {
    name: 'Snippets',
    components: {
      draggable,
    },
    data: () => {
      return {
        dialog_sort: false,
        dialog_add: false,
        dialog_del: false,
        dialog_del_snippet: {},
        add_category_name: null,
        tab: 0,
      }
    },
    computed: {
      ...mapGetters([
        'getSnippets',
      ]),
      tabs: {
        get: function () {
          return this.getSnippets ? this.getSnippets : []
        },
        set: function () {
        }
      }
    },
    mounted() {
      this.querySnippets()
    },
    methods: {
      ...mapActions([
        'setToast',
        'querySnippets',
        'querySnippetCreate',
        'querySnippetUpdate',
        'querySnippetDelete',
        'querySnippetCategoryCreate',
        'querySnippetCategoryUpdate',
        'querySnippetCategorySort',
      ]),
      onAddCategory() {
        let data = {
          name: this.add_category_name,
          sort: this.getSnippets.length
        }
        this.querySnippetCategoryCreate(data)
        this.add_category_name = ''
        this.dialog_add = false
      },
      onSortCategorys() {
        let arr = []
        for (let tab of this.tabs)
          arr.push(tab.id)

        this.querySnippetCategorySort(arr)
      },

      onAddSnippet() {
        if (this.getSnippets.length) {
          let data = {
            snippet_category_id: this.getSnippets[this.tab].id,
            sort: this.getSnippets[this.tab].snippets.length
          }
          this.querySnippetCreate(data)
        } else {
          this.setToast(['First create a category', 'warning'])
          this.dialog_add = true
        }
      },
      onChangeSnippet(event, snippet_id) {
        for (let snippet of this.tabs[this.tab].snippets)
          if (snippet.id == snippet_id && snippet.body !== event.target.innerText)
            this.querySnippetUpdate([snippet_id, {body: event.target.innerText}])
      },
      onSortSnippets(event) {
        let new_sort = event.moved.newIndex
        let old_sort = event.moved.oldIndex

        this.querySnippetUpdate([this.tabs[this.tab].snippets[new_sort].id, {sort: new_sort}])
        this.querySnippetUpdate([this.tabs[this.tab].snippets[old_sort].id, {sort: old_sort}])
      },
      onMoveSnippet(snippet_id, category_id) {
        this.querySnippetUpdate([snippet_id, {snippet_category_id: category_id}])
      },
      onDeleteSnippet(snippet) {
        this.dialog_del = true
        this.dialog_del_snippet = snippet
      },
      onConfirmSnippetDel() {
        this.querySnippetDelete(this.dialog_del_snippet.id)
        this.dialog_del = false
        this.dialog_del_snippet = {}
      }
    }
  }
</script>

<style lang="scss">
  #snippets {
    .snippet {
      overflow: hidden;
      .ps {
        height: 140px;
        width: 100%;
        margin-top: 10px;
        .v-card__text:focus {
          outline: 0
        }
        .snippet_edit_area {
          min-height: 130px;
        }
      }
      .manage {
        position: relative;
        border-bottom: 1px solid #333;
        height: 30px;
      }
    }
  }
</style>